import React from "react";
import { useIntl } from "react-intl";
import Dialog from "components/organisms/Dialog/Dialog";
import { QuickRequestDetails } from "./quotes/QuotesType";

interface IConsolidatedModalProps {
  data: QuickRequestDetails[];
  isOpen: boolean;
  close: () => void;
}

function ConsolidatedModal({ data, isOpen, close }: IConsolidatedModalProps) {
  const intl = useIntl();
  return (
    <Dialog
      size="sm"
      show={isOpen}
      onHide={close}
      viewOrders
      title={intl.formatMessage({ id: "orderTypeSelection.ConsolidatedOrder", defaultMessage: "Consolidated orders" })}
    >
      <div className="d-flex flex-column consolidated-order-list mt-lg">
        {data?.map((order: QuickRequestDetails, index: number) => (
          <div key={index} className="d-flex order-list mt-md">
            <div className="font-b2 order-number mr-sm">{index + 1}.</div>{" "}
            <a
              className="font-b2 font-bold"
              target="_blank"
              rel="noopener noreferrer"
              href={`/shipment/${order?.quick_request_reference}/quick`}
            >
              {order?.quick_request_reference}
            </a>
          </div>
        ))}
      </div>
    </Dialog>
  );
}

export default ConsolidatedModal;
